<template>
  <modal v-if="modalPlaceOrder" v-model:show="showModal" :showClose="false" :clickClose="false">
    <template v-slot:header>
      <h5 class="modal-title">You are about to place an Order for user </h5>
    </template>
    <form id="my-form">
      <div class="mb-3">
        <div class="row">
          <div class="col-sm-6 col-12  mt-3 mt-sm-0">
            <label class="text-black text-xs font-weight-bold text-capitalize">OTP:</label>
            <input type="text" v-model="placeOrder.placeOrderOtp"
              @input="() => { this.placeOrder.placeOrderValidOtp = false; }" class="form-control" id="recipient-name">
            <small v-if="placeOrder.placeOrderValidOtp" class="text-danger">otp must be not empty <br /></small>
          </div>
          <div class="col-sm-6 col-12">
            <label class="text-black text-xs font-weight-bold text-capitalize">Trade Term:</label>
            <select class="multisteps-form__select form-control" v-model="placeOrder.tradeTermId"
              @change="() => { this.placeOrder.tradeTermIdFlag = false; }">
              <option value='0'>Select TradeTerm</option>
              <option value='1'>INTRADAY</option>
              <option value='2'>OVERNIGHT</option>
            </select>
            <small v-if="this.placeOrder.tradeTermIdFlag" class="text-danger">Trade term must be selected</small>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 col-12  mt-3 mt-sm-0">
            <label class="text-black text-xs font-weight-bold text-capitalize">variation:</label>
            <input type="number" v-model="placeOrder.placeOrderVariation"
              @input="() => { this.placeOrder.placeOrderVariationFlag = false; }" class="form-control"
              id="recipient-name">
            <small v-if="placeOrder.placeOrderVariationFlag" class="text-danger">{{
    placeOrder.placeOrderVariationMessage }}
              <br /></small>
          </div>
          <div class="col-sm-6 col-12">
            <label class="text-black text-xs font-weight-bold text-capitalize">quantity:</label>
            <input type="number" v-model="placeOrder.placeOrderQuantity"
              @input="() => { this.placeOrder.placeOrderQuantityFlag = false; }" class="form-control"
              id="recipient-name">
            <small v-if="placeOrder.placeOrderQuantityFlag" class="text-danger">{{
    placeOrder.placeOrderQuantityMessage }}<br /></small>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 col-12  mt-3 mt-sm-0">
            <label class="text-black text-xs font-weight-bold text-capitalize">exchange</label>
            <select class="multisteps-form__select form-control" placeholder="Select Exchange"
              v-model="placeOrder.exchanges" @change="() => { this.placeOrder.exchangesFlag = false; }">
              <option selected="selected">Select Exchange</option>
              <option value="NSE">NSE</option>
              <option value="NFO">NFO</option>
            </select>
            <small v-if="placeOrder.exchangesFlag" class="text-danger">exchanges must be selected</small>
          </div>
          <div class="col-sm-6 col-12">
            <label class="text-black text-xs font-weight-bold text-capitalize">trigger</label>
            <select class="multisteps-form__select form-control" v-model="placeOrder.triggers"
              @change="() => { this.placeOrder.triggersFlag = false; }">
              <option selected="selected">Select Trigger</option>
              <option value="BUY">BUY</option>
              <option value="SHORT">SHORT</option>
            </select>
            <small v-if="placeOrder.triggersFlag" class="text-danger">trigger must be selected</small>
          </div>
        </div>
        <label class="text-black text-xs font-weight-bold text-capitalize">trading Symbol:</label>
        <input type="text" v-model="placeOrder.tradingSymbol" @input="() => { this.placeOrder.symbolFlag = false; }"
          class="form-control">
        <small v-if="placeOrder.symbolFlag" class="text-danger">tradingSymbol must be not empty<br /></small>
      </div>
    </form>
    <template v-slot:footer>
      <button type="button" class="btn  py-2 px-4 btn-secondary" data-bs-dismiss="modal" @click="() => {
    this.otp = ''; this.validOtp = false;
    this.placeOrder.tradeTermId = '0'; this.placeOrder.placeOrderQuantity = 1;
    this.errorFlag = false;
    closeModal();
  }">Close</button>
      <button class="btn  py-2 px-4 btn-primary text-capitalize" type="button" @click="validPlaceholder()">Place
        Order</button>
      <div v-if="errorFlag" class="d-flex justify-content-center m-3"><small class="text-danger">{{ errorMessage}}
        </small></div>
    </template>
  </modal>
</template>
<script>
import Modal from "@/components/Modal";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
export default {
  components: {
    Modal,
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    modalPlaceOrder: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      users: [],
      currentUser: {},
      otp: "",
      placeOrder: {
        placeOrderOtp: "",
        placeOrderVariation: 1,
        placeOrderVariationMessage: "",
        tradeTermId: '0',
        placeOrderValidOtp: false,
        placeOrderVariationFlag: false,
        placeOrderInstrumentFlag: false,
        exchangesFlag: false,
        triggersFlag: false,
        symbolFlag: false,
        placeOrderQuantityFlag: false,
        placeOrderQuantity: 1,
        tradeTermIdFlag: false,
        exchanges: "Select Exchange",
        triggers: "Select Trigger",
        placeOrderInstrument: "",
        placeOrderQuantityMessage: "",
        trigerChoice: null,
        exchangeChoice: null,
        tradeTermChoice: null,
        tradingSymbol: "",
        quantityFlag: "",
        modalPlaceOrder: false,
      },
      validOtp: false,
      errorFlag: false,
      errorMessage: "",
      statusEnum: {},
      token: ""
    }
  },
  methods: {
    closeModal() {
      this.placeOrder.placeOrderOtp = '',
        this.placeOrder.placeOrderInstrument = "";
      this.placeOrder.placeOrderVariation = 1;
      this.placeOrder.triggers = "Select Trigger";
      this.placeOrder.exchanges = "Select Exchange",
        this.placeOrder.tradingSymbol = "";
      this.placeOrder.placeOrderOtp = "";
      this.placeOrder.placeOrderValidOtp = false;
      this.placeOrder.placeOrderVariationFlag = false;
      this.placeOrder.placeOrderInstrumentFlag = false;
      this.placeOrder.exchangesFlag = false;
      this.placeOrder.triggersFlag = false;
      this.placeOrder.symbolFlag = false;
      this.placeOrder.tradeTermId = '0';
      this.placeOrder.tradeTermIdFlag = false;
      this.placeOrder.placeOrderQuantity = 1;
      this.errorFlag = false;
      this.$emit('updateParameters', false, false);
    },
    validPlaceholder() {
      this.placeOrder.placeOrderQuantityFlag = !this.placeOrder.placeOrderQuantity || this.placeOrder.placeOrderQuantity < 1 ? true : false;
      this.placeOrder.placeOrderVariationFlag = this.placeOrder.placeOrderVariation < 1 || !this.placeOrder.placeOrderVariation ? true : false;
      this.errorFlag = false;
      this.placeOrder.symbolFlag = this.placeOrder.tradingSymbol.length == 0 ? true : false;
      this.placeOrder.placeOrderValidOtp = this.placeOrder.placeOrderOtp.length == 0 ? true : false;
      this.placeOrder.placeOrderInstrumentFlag = this.placeOrder.placeOrderInstrument.length == 0 ? true : false;
      this.placeOrder.exchangesFlag = this.placeOrder.exchanges.length == 0 || this.placeOrder.exchanges == "Select Exchange" ? true : false;
      this.placeOrder.triggersFlag = this.placeOrder.triggers.length == 0 || this.placeOrder.triggers == "Select Trigger" ? true : false;
      this.placeOrder.tradeTermIdFlag = this.placeOrder.tradeTermId.length == 0 || this.placeOrder.tradeTermId == "0" ? true : false;
      if (this.placeOrder.placeOrderQuantity.toString().length == 0) {
        this.placeOrder.placeOrderQuantityMessage = "Quantity must be not empty";
      }
      else if (this.placeOrder.placeOrderQuantity < 1) {
        this.placeOrder.placeOrderQuantityMessage = "Quantity must be greater than zero";
      }
      else {
        this.placeOrder.placeOrderQuantityMessage = "";
      }
      if (this.placeOrder.placeOrderVariation.toString().length == 0) {
        this.placeOrder.placeOrderVariationMessage = "variation must be not empty";
      }
      else if (this.placeOrder.placeOrderVariation < 1) {
        this.placeOrder.placeOrderVariationMessage = "variation must be greater than zero";
      }
      else {
        this.placeOrder.placeOrderVariationMessage = "";
      }
      if (!(this.placeOrder.symbolFlag || this.placeOrder.placeOrderValidOtp
        || this.placeOrder.exchangesFlag || this.placeOrder.triggersFlag || this.placeOrder.tradeTermIdFlag ||
        this.placeOrder.placeOrderQuantityFlag || this.placeOrder.placeOrderVariationFlag)) {
        this.OrderPlacement();
        this.placeOrder.symbolFlag = false;
        this.placeOrder.placeOrderValidOtp = false;
        this.placeOrder.placeOrderVariationFlag = false;
        this.placeOrder.placeOrderInstrumentFlag = false;
        this.placeOrder.tradeTermIdFlag = false;
        this.placeOrder.exchangesFlag = false;
        this.placeOrder.triggersFlag = false;
      }
    },
    async OrderPlacement() {
      var self = this;
      var reqData = {
        "userId": self.currentUser.userId,
        "instrument": self.tradingSymbol,
        "body": {
          "otp": self.placeOrder.placeOrderOtp,
          "variation": self.placeOrder.placeOrderVariation,
          "trigger": self.placeOrder.triggers,
          "exchange": self.placeOrder.exchanges,
          "tradeTermId": self.placeOrder.tradeTermId,
          "quantity": self.placeOrder.placeOrderQuantity,
        },
      }
      let data = {}
      data.token = self.token;
      data.payload = reqData
      self.$store
        .dispatch("settingStore/placeOrder", data, { root: true })
        .then(function (response) {
          self.$emit('updateParameters', false, false);
          swal.fire({
            title: "Order Placed!",
            text: "Request for place order are placed.",
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-success",
            },
            icon: "success",
          });
          self.placeOrder.placeOrderVariation = 1;
          self.placeOrder.triggers = "Select Trigger";
          self.placeOrder.exchanges = "Select Exchange";
          self.placeOrder.tradingSymbol = "";
          self.placeOrder.placeOrderOtp = "";
          console.log(response);
        }).catch(function (error) {
          self.errorFlag = true;
          self.errorMessage = error.server.response.data.message;
        });
    },
  },
};
</script>